/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OutreachDeliveryStatus = {
    Pending: 'pending',
    Delivered: 'delivered',
    Bounced: 'bounced',
    Complained: 'complained',
    Suppressed: 'suppressed',
    Failed: 'failed',
} as const;
export type OutreachDeliveryStatus = typeof OutreachDeliveryStatus[keyof typeof OutreachDeliveryStatus];


export function instanceOfOutreachDeliveryStatus(value: any): boolean {
    for (const key in OutreachDeliveryStatus) {
        if (Object.prototype.hasOwnProperty.call(OutreachDeliveryStatus, key)) {
            if (OutreachDeliveryStatus[key as keyof typeof OutreachDeliveryStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OutreachDeliveryStatusFromJSON(json: any): OutreachDeliveryStatus {
    return OutreachDeliveryStatusFromJSONTyped(json, false);
}

export function OutreachDeliveryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutreachDeliveryStatus {
    return json as OutreachDeliveryStatus;
}

export function OutreachDeliveryStatusToJSON(value?: OutreachDeliveryStatus | null): any {
    return value as any;
}

export function OutreachDeliveryStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): OutreachDeliveryStatus {
    return value as OutreachDeliveryStatus;
}

